<template>
  <div>
    <b-row>
      <b-col cols="8">
        <div>
          <h2>{{ $t("fuelSupply.title") }}</h2>
        </div>
        <div>
          <router-link
            :to="`/checklist/Layout/form/fill/${$store.getters.formFuelSupplyId}`"
          >
            <b-button size="sm">
              {{ $t("fuelSupply.createSupply") }}
            </b-button>
          </router-link>
          <b-button
            size="sm"
            class="ml-2 btn-checklist cleanFilters"
            @click="filtersClean"
          >
            {{ $t("geral.cleanFilters") }}
          </b-button>

          <b-button
            size="sm"
            class="ml-2 btn-checklist cleanFilters"
            @click="configForm"
            v-if="userRms"
          >
            {{ $t("geral.fuelSupplyFormConfig") }}
          </b-button>
          <b-button
            size="sm"
            class="ml-2 btn-checklist cleanFilters"
            @click="$refs.table.refresh()"
          >
            <i
              class="material-icons"
              style="font-size: 18px; vertical-align: middle; margin-right: 5px"
            >
              refresh
            </i>
            {{ $t("geral.refresh") }}
          </b-button>
        </div>
      </b-col>

      <b-col
        cols="4"
        style="display: flex; justify-content: flex-end; align-items: flex-end"
      >
        <base-event-timer
          :timer.sync="eventTimer"
          :lastRefreshTime="lastRefreshTime"
        ></base-event-timer>
        <!-- {{eventTimer}} -->
      </b-col>
    </b-row>

    <div v-if="isLoadingFilters">
      <div class="text-center my-2">
        <b-spinner class="align-middle"></b-spinner>
        <strong>{{ $t("geral.loadingData") }}</strong>
      </div>
    </div>
    <div v-else>
      <b-table
        ref="table"
        id="my-table"
        class="table-nowrap"
        :busy.sync="isBusy"
        :items="myProvider"
        :fields="fields"
        :per-page="tablePerPage"
        current-page="0"
        :filter.sync="tableFilters"
        :filter-debounce="500"
        :responsive="true"
        selectable
        @context-changed="contextChanged"
      >
        <template #head()="data">
          <div style="display: inline-block">
            {{ data.label.toUpperCase() }}
          </div>
          <div
            v-if="data.field.tooltip"
            class="ml-2"
            style="display: inline-block"
          >
            <b-icon
              :title="data.field.tooltip"
              v-b-tooltip.hover
              icon="info-circle"
            ></b-icon>
          </div>
        </template>
        <template slot="thead-top" slot-scope="{ fields }">
          <b-tr>
            <b-th
              v-for="field in fields"
              :key="field.filterKey"
              class="vertical-align"
            >
              <div v-if="field.key == 'actions'">
                <b-button
                  size="sm"
                  class="btn-checklist cleanFilters"
                  @click="filtersClean"
                >
                  {{ $t("geral.cleanFilters") }}
                </b-button>
              </div>
              <div v-else-if="tableFilters[field.key] != null">
                <div v-if="field.filterType == 'dateRange'">
                  <base-filter-date
                    ref="baseFilterDate"
                    :dateFill.sync="tableFilters[field.filterDateEquals]"
                    :dateBegin.sync="tableFilters[field.filterDateBegin]"
                    :dateEnd.sync="tableFilters[field.filterDateEnd]"
                    :filterName.sync="field.label"
                    :optionFilterDate.sync="optionFilterDate"
                    :filterDates="filterDateApplied"
                  ></base-filter-date>
                </div>
                <div v-else-if="field.filterType == 'double'">
                  <b-form-input type="text" v-model="tableFilters[field.key]" />
                </div>
                <div v-else-if="field.filterType == 'markerType'">
                  <b-form-select
                    v-model="tableFilters[field.key]"
                    :options="markerTypeOpt"
                  >
                  </b-form-select>
                </div>
                <div v-else>
                  <b-form-input
                    v-model="tableFilters[field.filterKey]"
                    :placeholder="'Buscar por ' + field.label"
                    class="idStyle"
                  />
                </div>
              </div>
            </b-th>
          </b-tr>
        </template>
        <template v-slot:cell(actions)> </template>
        <template v-slot:cell(checklistId)="data">
          <router-link
            :to="'/checklist/form/filled/details/' + data.item.checklistId"
          >
            <p>
              <u>
                {{ data.value }}
              </u>
            </p>
          </router-link>
        </template>
        <!-- <template v-slot:cell(action)="data">
          <div>
            <router-link
              v-if="data.item.approvalDate != null"
              :to="'/checklist/Layout/form/PedenciesDetails/' + data.item.id"
            >
              <b-button size="sm">{{ $t("checklist.form.Details") }}</b-button>
            </router-link>
            <router-link
              v-else
              :to="'/checklist/Layout/form/PedenciesDetails/' + data.item.id"
            >
              <b-button size="sm">
                {{ $t("checklist.form.Details") }}
              </b-button>
            </router-link>
          </div>
        </template> -->
      </b-table>
    </div>
    <div>
      <table-pagination-range
        :currentPage.sync="tableCurrentPage"
        :pageOptions.sync="tablePageOptions"
        :perPage.sync="tablePerPage"
        :rowCount.sync="tableRowCount"
        @homePage="homePage"
        @prevPage="prevPage"
        @nextPage="nextPage"
      >
      </table-pagination-range>
    </div>
  </div>
</template>

<script>
import TablePaginationRange from "@/components_rms/base/TablePaginationRange.vue";

export default {
  components: {
    TablePaginationRange,
    BaseFilterDate: () => import("@/components_rms/base/BaseFilterDate.vue"),
    BaseEventTimer: () => import("@/components_rms/base/BaseEventTimer.vue"),
  },
  props: {},
  data: function () {
    return {
      fields: [
        {
          key: "checklistId",
          filterKey: "checklistId",
          sortable: false,
          label: "Abastecimento",
          thStyle: "width: 110px",
        },
        {
          key: "date",
          filterKey: "date",
          sortable: false,
          label: "Data",
          filterType: "dateRange",
          filterDateEquals: "date",
          filterDateBegin: "dateBegin",
          filterDateEnd: "dateEnd",
          thStyle: "width: 110px",
        },
        {
          key: "currentKm",
          filterKey: "currentKm",
          sortable: false,
          label: "Marcador Atual",
          tooltip: "Marcador atual do hodômetro / horímetro",
          thStyle: "width: 110px",
          thClass: "td-number",
          tdClass: "td-number",
        },
        {
          key: "kmDriven",
          filterKey: "kmDriven",
          sortable: false,
          label: "Registro Marcador",
          tooltip: "Registro feito no marcador (KM RODADO / HORA TRABALHADA)",
          thStyle: "width: 110px",
          thClass: "td-number",
          tdClass: "td-number",
        },
        {
          key: "fullSupply",
          filterKey: "fullSupply",
          sortable: false,
          label: "Completou",
          thStyle: "width: 110px",
          thClass: "td-number",
          tdClass: "td-number",
        },
        {
          key: "liters",
          filterKey: "liters",
          sortable: false,
          label: "Litros",
          thStyle: "width: 110px",
          thClass: "td-number",
          tdClass: "td-number",
        },
        {
          key: "price",
          filterKey: "price",
          sortable: false,
          label: "Preço",
          thStyle: "width: 110px",
          thClass: "td-number",
          tdClass: "td-number",
        },
        {
          key: "totalValue",
          filterKey: "totalValue",
          sortable: false,
          label: "Valor Total",
          thStyle: "width: 110px",
          thClass: "td-number",
          tdClass: "td-number",
        },
        {
          key: "fuelType",
          filterKey: "fuelType",
          sortable: false,
          label: "Tipo de Combustível",
          thStyle: "width: 160px",
        },
        {
          key: "goal",
          filterKey: "goal",
          sortable: false,
          label: "Meta",
          thStyle: "width: 110px",
          thClass: "td-number",
          tdClass: "td-number",
        },
        {
          key: "average",
          filterKey: "average",
          sortable: false,
          label: "Média",
          thStyle: "width: 110px",
          thClass: "td-number",
          tdClass: "td-number",
        },
        {
          key: "economy",
          filterKey: "economy",
          sortable: false,
          label: "Economia",
          thStyle: "width: 110px",
          thClass: "td-number",
          tdClass: "td-number",
        },
        {
          key: "plate",
          filterKey: "plate",
          sortable: false,
          label: "Placa",
          thStyle: "width: 110px",
        },
        {
          key: "driver",
          filterKey: "driver",
          sortable: false,
          label: "Motorista",
          thStyle: "width: 110px",
        },
        {
          key: "litersArla",
          filterKey: "litersArla",
          sortable: false,
          label: "Litros Arla",
          thStyle: "width: 110px",
          thClass: "td-number",
          tdClass: "td-number",
        },
        {
          key: "valueArla",
          filterKey: "valueArla",
          sortable: false,
          label: "Valor Arla",
          thStyle: "width: 110px",
          thClass: "td-number",
          tdClass: "td-number",
        },
      ],
      tableFilters: {
        checklistId: "",
        date: "",
        dateBegin: "",
        dateEnd: "",
        currentKm: "",
        kmDriven: "",
        liters: "",
        price: "",
        totalValue: "",
        fuelType: "",
        goal: "",
        average: "",
        economy: "",
        plate: "",
        vehicleModel: "",
        driver: "",
        litersArla: "",
        valueArla: "",
        vehicleMarkerType: null,
        fullSupply: "",
      },
      tableItems: [],
      eventTimer: {
        id: 0,
        userId: 0,
        eventTimerMiliseconds: 0,
        eventTimerSeconds: 0,
        pageUrl: "",
      },
      isBusy: false,
      isLoadingFilters: false,
      tableRowCount: 0,
      tableCurrentPage: 1,
      tablePerPage: 10,
      tablePageOptions: [10, 25, 50, 100, 150],
      optionFilterDate: 0,
      refreshTime: 0,
      timer: null,
      lastRefreshTime: null,
      filterDateApplied: [],
      markerTypeOpt: [
        { value: null, text: "Selecione um marcador" },
        { value: 0, text: "Hodômetro" },
        { value: 1, text: "Horimetro" },
      ],
      userRms: false,
    };
  },
  computed: {
    paginationFrom() {
      return this.tablePerPage * (this.tableCurrentPage - 1) + 1;
    },
    paginationTo() {
      let to = this.paginationFrom - 1 + this.tablePerPage;
      if (to > this.tableRowCount) return this.tableRowCount;
      return to;
    },
  },
  created() {
    this.myProviderCount();
    this.isRmsUser();
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    async isRmsUser() {
      this.$apiScheduler.get("/user/isRms").then((response) => {
        this.userRms = response.data;
      });
    },
    filtersClean() {
      this.tableFilters = {
        fuelSupplyId: "",
        checklistId: "",
        date: "",
        dateBegin: "",
        dateEnd: "",
        currentKm: "",
        kmDriven: "",
        liters: "",
        price: "",
        totalValue: "",
        fuelType: "",
        goal: "",
        average: "",
        economy: "",
        plate: "",
        vehicleModel: "",
        driver: "",
        litersArla: "",
        valueArla: "",
        vehicleMarkerType: null,
        fullSupply: "",
      };
    },
    init() {
      this.$refs.table.refresh();
    },
    refreshPage() {
      // if (this.eventTimer.eventTimerMiliseconds == 0) return;
      this.timer = setInterval(
        this.init,
        this.eventTimer.eventTimerMiliseconds
      );
    },
    myProvider(ctx, callback) {
      if (this.isLoadingFilters) {
        this.isBusy = false;
        callback([]);
      }

      this.lastRefreshTime = new Date();
      this.isBusy = true;
      let apiFilter = {
        currentPage: this.tableCurrentPage,
        perPage: this.tablePerPage,
        fuelSupplyId: this.tableFilters.fuelSupplyId,
        checklistId: this.tableFilters.checklistId,
        dateEquals: this.tableFilters.date,
        dateBegin: this.tableFilters.dateBegin,
        dateEnd: this.tableFilters.dateEnd,
        currentKm: this.tableFilters.currentKm,
        kmDriven: this.tableFilters.kmDriven,
        liters: this.tableFilters.liters,
        price: this.tableFilters.price,
        totalValue: this.tableFilters.totalValue,
        fuelType: this.tableFilters.fuelType,
        goal: this.tableFilters.goal,
        average: this.tableFilters.average,
        economy: this.tableFilters.economy,
        plate: this.tableFilters.plate,
        vehicleModel: this.tableFilters.vehicleModel,
        driver: this.tableFilters.driver,
        litersArla: this.tableFilters.litersArla,
        valueArla: this.tableFilters.valueArla,
        vehicleMarkerType: this.tableFilters.vehicleMarkerType,
        fullSupply: this.tableFilters.fullSupply,
      };
      this.$apiVehicle
        .post("/fuelSupply/paginate/list", apiFilter)
        .then((response) => {
          const items = response.data;
          this.isBusy = false;
          this.tableItems = items;
          callback(items);
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.isBusy = false;
            this.tableItems = [];
            callback([]);
          }
        });
      return null;
    },
    async myProviderCount() {
      if (this.isLoadingFilters) {
        this.tableRowCount = 0;
      }
      let apiFilter = {
        currentPage: this.tableCurrentPage,
        perPage: this.tablePerPage,
        fuelSupplyId: this.tableFilters.fuelSupplyId,
        checklistId: this.tableFilters.checklistId,
        dateEquals: this.tableFilters.date,
        dateBegin: this.tableFilters.dateBegin,
        dateEnd: this.tableFilters.dateEnd,
        currentKm: this.tableFilters.currentKm,
        kmDriven: this.tableFilters.kmDriven,
        liters: this.tableFilters.liters,
        price: this.tableFilters.price,
        totalValue: this.tableFilters.totalValue,
        fuelType: this.tableFilters.fuelType,
        goal: this.tableFilters.goal,
        average: this.tableFilters.average,
        economy: this.tableFilters.economy,
        plate: this.tableFilters.plate,
        vehicleModel: this.tableFilters.vehicleModel,
        driver: this.tableFilters.driver,
        litersArla: this.tableFilters.litersArla,
        valueArla: this.tableFilters.valueArla,
        vehicleMarkerType: this.tableFilters.vehicleMarkerType,
        fullSupply: this.tableFilters.fullSupply,
      };
      this.$apiVehicle
        .post("/fuelSupply/paginate/count", apiFilter)
        .then((response) => {
          this.tableRowCount = response.data;
          // this.refresh();
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.tableRowCount = 0;
          }
        });
    },
    homePage() {
      this.tableCurrentPage = 1;
      this.$refs.table.refresh();
    },
    nextPage() {
      this.tableCurrentPage++;
      this.$refs.table.refresh();
    },
    prevPage() {
      this.tableCurrentPage--;
      this.$refs.table.refresh();
    },
    contextChanged() {
      this.tableCurrentPage = 1;
      this.myProviderCount();
    },
    configForm() {
      this.$router.push("/checklist/fuelSupplies/formConfiguration");
    },
  },
  watch: {
    eventTimer() {
      clearInterval(this.timer);
      this.refreshPage();
    },
  },
};
</script>
<style scoped>
.vertical-align {
  vertical-align: bottom !important;
}
.left {
  margin-left: 0px !important;
}
</style>
